import { DictionaryEvidence, TableColumn } from '@eas/common-web';
import { WorkOrderType } from '@models';

export function useColumns(): TableColumn<WorkOrderType>[] {
  const dictionaryColumns =
    DictionaryEvidence.useDictionaryColumns<WorkOrderType>();

  return [dictionaryColumns.columnName];
}
